import { DownloadIcon } from 'components/icons'
import { useOnboarding } from 'context/onboarding-context'
import { useState } from 'react'
import { useDropzone } from 'react-dropzone'

const ToolLibraryDropzone = () => {
  const fileTypes = ['.tools', '.json']
  const [isDropping, setIsDropping] = useState(false)
  const { setToolLibrary, setToolLibraryFile } = useOnboarding()

  const { getRootProps, getInputProps, open } = useDropzone({
    accept: fileTypes,
    multiple: false,
    noKeyboard: true,
    onDropAccepted: async (files) => {
      const file = files.shift()
      setIsDropping(false)
      setToolLibraryFile(file)
      setToolLibrary({ fileName: file.name })
    },
    onDropRejected: (fileRejections) => {
      const fileRejection = fileRejections.shift()
      setIsDropping(false)
      setToolLibrary({
        fileName: fileRejection.file.name,
        error: fileRejection.errors.shift().message,
      })
    },
    onDragLeave: () => setIsDropping(false),
    onDragEnter: () => setIsDropping(true),
  })

  return (
    <div
      {...getRootProps()}
      tabIndex={0}
      className="group flex h-40 min-h-40 w-full flex-1 flex-col items-center justify-center rounded-xl border border-gray-100 outline-none ring-info/75 hover:border-gray-200 focus-visible:ring-2 lg:w-1/2">
      <div className="flex flex-col items-center gap-1.5 transition duration-300 ease-in-out group-hover:scale-105 group-focus:scale-105">
        {isDropping && (
          <DownloadIcon className="size-10 animate-bounce text-info" />
        )}
        <span className="font-semibold text-gray">Upload a Fusion Library</span>
        <div className="flex w-full flex-row items-center justify-center gap-2 border-t border-gray-100 px-6 py-3">
          {fileTypes.map((fileType) => {
            return (
              <span
                key={fileType}
                className="rounded-lg border border-gray-200 bg-gray-200 px-2 py-0.5 font-body text-xs font-bold uppercase text-white ">
                {fileType} {fileType === '.f3d' && 'cam file'}
              </span>
            )
          })}
        </div>
      </div>
      <input name="file" id="file-input" {...getInputProps()} />
    </div>
  )
}

export default ToolLibraryDropzone
